<template>
    <div id="root-container">
      <a-layout>
        <a-layout-sider>
          <div class="logo-wrap pc-brand" :title="site.site_name || 'PC'">
            <img v-if="pcLogo && failedLogo !== pcLogo" :src="pcLogo" :alt="site.site_name || 'PC Logo'" @error="failedLogo = pcLogo">
          </div>
          <ul class="sidebar-menu">
            <li class="sidebar-menu-item" :class="{'active': curSideIndex === 0}" @click="setSide(0)">
              <div>
                <i class="el-icon-data-analysis" aria-hidden="true"></i>
              </div>
              <div>行情</div>
            </li>
            <li class="sidebar-menu-item" :class="{'active': curSideIndex === 1}" @click="setSide(1)">
              <div>
                <i class="el-icon-aim" aria-hidden="true"></i>
              </div>
              <div>交易</div>
            </li>
            <li class="sidebar-menu-item" :class="{ active: curSideIndex === 7 }" @click="setSide(7)"><div><i class="el-icon-present" aria-hidden="true"></i></div><div>活动</div></li>
            <!-- <li class="sidebar-menu-item" :class="{'active': curSideIndex === 2}" @click="setSide(2)">
              <div>
                <i class="icon iconfont icon--hangqing"></i>
              </div>
              <div>合约</div>
            </li> -->
            <li class="sidebar-menu-item" :class="{'active': curSideIndex === 3}" @click="setSide(3)">
              <div>
                <i class="el-icon-wallet" aria-hidden="true"></i>
              </div>
              <div>账户</div>
            </li>
            <li class="sidebar-menu-item" :class="{'active': curSideIndex === 4}" @click="setSide(4)">
              <div>
                <svg class="sidebar-news-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 4h15v15a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8h3M6 4v15a2 2 0 0 1-2 2M9 8h9M9 11h9M9 14h3v4H9zM15 14h3M15 18h3" /></svg>
              </div>
              <div>资讯</div>
            </li>
            <li class="sidebar-menu-item" :class="{ active: curSideIndex === 6 }" @click="setSide(6)"><div><i class="el-icon-message" aria-hidden="true"></i></div><div>消息</div></li>
            <li class="sidebar-menu-item" :class="{ active: curSideIndex === 8 }" @click="setSide(8)"><div><svg class="sidebar-news-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 11v6M12 7h.01"/></svg></div><div>关于</div></li>
            <li class="sidebar-menu-item" :class="{'active': curSideIndex === 5}" @click="setSide(5)">
              <div><i class="el-icon-setting" aria-hidden="true"></i></div>
              <div>设置</div>
            </li>
            <li><button type="button" class="sidebar-menu-item sidebar-support-trigger" :class="{ 'is-minimized': supportState.minimized }" :title="supportState.minimized ? '客服会话已收起，点击继续咨询' : '客服'" :disabled="supportState.opening" @click="openSupport"><i class="el-icon-service" aria-hidden="true"></i><span>客服</span></button></li>
            <li v-if="linesAvailable"><button type="button" class="sidebar-lines-trigger" :class="{ connected: lineConnected }" title="点击切换线路" aria-label="点击切换线路" @click="$root.$emit('select-lines')"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><path d="M3 8.5a14 14 0 0 1 18 0M6 12a9 9 0 0 1 12 0M9 15.5a4.5 4.5 0 0 1 6 0"/><circle cx="12" cy="19" r="1" fill="currentColor" stroke="none"/></svg></button></li>
          </ul>
        </a-layout-sider>
        <a-layout class="app-main-layout">
          <a-layout-content class="app-main-content">
            <router-view v-if="config.ready && routeAllowed" /><section v-else class="config-state" role="status"><p>{{ config.error || (!config.ready ? '正在加载系统配置…' : '当前板块暂未开放') }}</p><el-button v-if="config.error" @click="reloadConfig">重试</el-button><el-button v-if="config.ready" @click="$router.push('/market/cn')">返回沪深行情</el-button><p v-if="config.ready">原有资金记录仍可到账户中查看。</p></section>
          </a-layout-content>
          <MarketTicker v-if="config.ready" />
        </a-layout>
      </a-layout>
      <HomeAnnouncement v-if="config.ready && $route.name === 'MarketHome'" />
      <el-dialog title="账户信息" :visible.sync="userVisible" center width="60%">
        <el-container style="height: 400px;color: var(--theme-text)">
          <el-aside width="200px">
            <el-col>
              <el-menu
                  default-active="1"
                  class="el-menu-vertical-demo"
                  active-text-color="#ffd04b">
                <el-menu-item index="1" @click="msgClick(1)">
                  <i class="el-icon-menu"></i>
                  <span slot="title">用户信息</span>
                </el-menu-item>
              </el-menu>
            </el-col>
          </el-aside>
          <el-main>
            <el-row :gutter="20">
              <el-col :span="6">头像</el-col>
              <el-col :span="6">
                <img :src="imageUrl(site.site_ico)" width="40px" alt="">
              </el-col>
              <el-col :span="6">
                <el-button type="info" :loading="loggingOut" :disabled="loggingOut" @click="loginout()">退出登录</el-button>
              </el-col>
            </el-row>
          </el-main>
        </el-container>
      </el-dialog>
    </div>
</template>
  
  <script>

  import {apiConfig, apiLogout, apiStockListByCate} from "@/utils/requestapis";
  import MarketTicker from '@/components/MarketTicker.vue';
  import HomeAnnouncement from '@/components/HomeAnnouncement.vue';
  import Router from "@/router";
  import {setCath} from "@/utils/cache";
  import { configkey } from "@/utils/configkey";
  import { BASEURL, isExe, resourceUrl } from '@/utils/realmName'
  import { systemConfig, loadSystemConfig, marketEnabled } from '@/utils/systemConfig'
  import { stockSelection } from '@/views/stock/stockSelection'

  export default {
    name: "app",
    components: { MarketTicker, HomeAnnouncement },
    inject: ['openSupport', 'supportState'],
    data() {
      return {
        curSideIndex: 0,
        outerVisible:false,
        innerVisible:false,
        list:[],
        submitInfo:{
          page:1,
          page_size:15,
        },
        domInfo:{
          title:'',
          content:'',
          create_time:''
        },
        titleBox:false,
        domIdx:1,
        kefuUrl:'',
        userVisible:false,
        loggingOut:false,
        site:{}, failedLogo: '', config: systemConfig, configTimer: null, networkOnline: navigator.onLine
      };
    },
    computed: { linesAvailable: isExe, lineConnected() { return this.networkOnline && this.config.ready && !this.config.error }, pcLogo() { return this.imageUrl(this.site.logo_exe, BASEURL()) }, routeAllowed() { return this.$route.path !== '/stocks' || marketEnabled(stockSelection(this.$route.query).market) } },
    beforeDestroy() { clearInterval(this.configTimer); window.removeEventListener('online', this.updateNetworkState); window.removeEventListener('offline', this.updateNetworkState) },
    mounted(){
      window.addEventListener('online', this.updateNetworkState)
      window.addEventListener('offline', this.updateNetworkState)
      let obj  = {
        "config_keys": {
          "site": [
            "company",  //公司名称
            "logo",  //logo地址
            "logo_image",//logo图
            "online_service_1", "online_service_2", "chat_switch", "is_meijia", "is_duomi", "is_miduoke", "meijia_uid", "duomi_uid", "miduoke_uid", "miduoke_domain",
            "online_service",//客服链接
            "site_beian",//网站备案信息
            "site_copyright",//网站备案信息
            "site_ico",//网站ioc图
            "site_name",//网站名称
            "site_version",//网站d
            "websocket",//websock  连接地址
            "frontDeskDomain", //前台域名地址
            "seo_title",  //seo标题
            "seo_keywords",//seo关键词
            "seo_description",//seo描述
            "invite_code_switch",//邀请码开关 0-关闭，1开启
            "frontDaoHangDomain"//导航站域名
          ],
          "app": [
            "android", //安卓下载页地址
            "android_scan",//安卓下载页二维码
            "iosApp",//苹果下载页地址
            "iosApp_scan",//苹果下载页二维码
            "iosH5_scan"//h5的页面
          ],
          "trade": [
            "holiday", "hk_holiday", "us_holiday",
            "trade_dj", //股票最低购买价格
          ],
          "consult": [
            "loss_warn_ratio", //股票预警线利率
            "loss_close_ratio", //股票强平线利率
          ],
        }
      };
      this.reloadConfig()
      this.configTimer = setInterval(() => { if (!document.hidden) this.reloadConfig() }, 60000)
    },
    watch: {
      '$route.fullPath'() { this.reloadConfig() },
      '$route.path': {
        immediate: true,
        handler(path) { this.handelInit(path); }
      }
    },
    methods: {
      updateNetworkState() { this.networkOnline = navigator.onLine },
      reloadConfig() { return loadSystemConfig().then(data => { this.site = data.site; this.kefuUrl = this.site.online_service }).catch(() => {}) },
      imageUrl: resourceUrl,
      handelInit(path) {
        let idx = ''
        switch (path) {
          case "/contract":
            idx = 2;
            break;
          case "/stocks":
            idx = 1;
            break;
          case "/account":
            idx = 3;
            break;
          case "/consult":
            idx = 4;
            break;
          case "/messages":
            idx = 6;
            break;
          case "/activities":
            idx = 7;
            break;
          case "/settings":
            idx = 5;
            break;
          case "/about":
            idx = 8;
            break;
          default:
            idx = 0;
            break;
        }
        this.curSideIndex = idx;
      },
      msgClick() { this.setSide(6) },
      loginout(){
          if (this.loggingOut) return
          this.loggingOut = true
          return apiLogout({}).then((res) => {
            if (res === 0 || res === undefined) return
          this.$alert('退出成功', '提示', {
            confirmButtonText: '确定',
            callback: action => {
              Router.push('/login').catch(err=>{})
            }
          });
          }).catch(() => { /* Shared interceptor reports request failures. */ }).finally(() => { this.loggingOut = false })
      },
      setSide(index) {
        this.curSideIndex = index;
        if (index === 1) {
          this.$router.push('/stocks')
        }else if(index === 2){
          this.$router.push('/contract')
        }else if(index === 3){
          this.$router.push('/account')
        }else if(index === 4){
          if (this.$route.path === '/consult') this.$root.$emit('news-refresh')
          else this.$router.push('/consult')
        }else if(index === 7){
          if (this.$route.path !== '/activities') this.$router.push('/activities')
        }else if(index === 6){
          if (this.$route.path !== '/messages') this.$router.push('/messages')
        }else if(index === 8){
          if (this.$route.path !== '/about') this.$router.push('/about')
        }else if(index === 5){
          this.$router.push('/settings')
        }else{
          this.$router.push('/')
        }
      },
    }
  };
  </script>
  
  <style lang="scss">
  @import "../../assets/normal.css";

  html,
  body,
  #root-container,
  .ant-layout {
    height: 100%;
    background: var(--theme-bg);
  }
  
  
  .ant-layout-sider {
    width: 76px !important;
    max-width: 76px !important;
    min-width: 76px !important;
  }
  
  #root-container .pc-brand {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 80px;
    flex: 0 0 80px;
    padding: 10px 8px;
    box-sizing: border-box;
  }
  #root-container .pc-brand img { display: block; width: 100%; height: 100%; object-fit: contain; }
  .ant-layout-sider-children { display: flex; flex-direction: column; height: 100%; }
  .ant-layout-sider-children > .sidebar-menu { flex: 1; min-height: 0; overflow-y: auto; margin: 0; padding: 0; list-style: none; scrollbar-width: thin; }
  /* Only support stays reachable above business masks; other menu items remain blocked. */
  #root-container .sidebar-support-trigger { position:relative; z-index:2147483000; background:var(--theme-bg); }
  #root-container .sidebar-support-trigger.is-minimized > i,
  #root-container .sidebar-support-trigger.is-minimized > span { animation:sidebar-support-pulse 2s ease-in-out infinite; }
  @keyframes sidebar-support-pulse { 0%, 100% { opacity:1; } 50% { opacity:.4; } }
  @media (prefers-reduced-motion: reduce) {
    #root-container .sidebar-support-trigger.is-minimized > i,
    #root-container .sidebar-support-trigger.is-minimized > span { animation:none; }
  }
  
  
  #root-container .sidebar-menu-item {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 4px;
    width: 100%;
    height: 60px;
    box-sizing: border-box;
    padding: 0;
    border: 0;
    background: transparent;
    font: inherit;
    font-size: 13px;
    line-height: 18px;
    cursor: pointer;
    color: var(--theme-label);
    i { display: block; width: 22px; height: 22px; font-size: 22px; line-height: 22px; color: inherit; }
    .sidebar-news-icon { display: block; width: 22px; height: 22px; }
    &.active, &:hover { color: var(--theme-accent); background: var(--theme-hover); }
    &:focus-visible { outline: 2px solid var(--theme-accent); outline-offset: -2px; }
  }
  @media (max-height: 600px) {
    #root-container .pc-brand { height: 56px; flex-basis: 56px; padding: 6px 8px; }
    #root-container .sidebar-menu-item { height: 52px; font-size: 12px; line-height: 16px; }
    #root-container .sidebar-menu-item i { width: 20px; height: 20px; font-size: 20px; line-height: 20px; }
    #root-container .sidebar-menu-item .sidebar-news-icon { width: 20px; height: 20px; }
  }

  .color-rise {
    width: 20%;
    height: 12px;
    background-color: var(--quote-up);
  }

  .color-fall {
    height: 12px;
    background-color: var(--quote-down);
  }
  
  .tool-bar .ant-btn-link {
    color: var(--theme-text);
  }
  
  /*
   今日股市
  */
  .jinrigushi-wrap {
    height: 100%;
  }


  // 今日投票
  .jinri {
    padding-left: 8px;
    line-height: 35px;
    height: 35px;
    color: var(--theme-text);
    background-color: var(--theme-bg);
  }

  // flex样式
  .flex {
    display: flex;
  }

  .flex-justify_between {
    justify-content: space-between;
  }
  
  .align-item__center {
    align-items: center;
  }
  
  .flex-1 {
    flex: 1;
  }
  
  .flex-2 {
    flex: 2;
  }

  .text-align_center {
    text-align: center;
  }

  .text-align__right{
    text-align: right;
  }

  .flex-direction__column {
    flex-direction: column;
  }

  .justify-content__center {
    justify-content: center;
  }

  .wdith-100 {
    width: 100%;
  }

  .mt-10{
    margin-top: 10px;
  }

  .mb-10 {
    margin-bottom: 10px;
  }

  .nowrap {
    white-space: nowrap;
    overflow: hidden;
  }
  .el-dialog__body {
    padding: 10px 15px;
    color: var(--theme-text);
    font-size: 14px;
    word-break: break-all;
    background: var(--theme-panel);
    height: auto;
    max-height: 70vh;
  }
  .el-menu{
    border-right: none !important;
    background-color:  inherit;
    color: var(--theme-label) !important;
  }
  .el-menu-item{
    color: var(--theme-label);
  }
  .main-box{
    color: var(--theme-muted);
    padding: 5px;
    min-height: 180px;
    //border-bottom: 1px dashed #303b4b;
  }
  .main-box2 img{
    height: 100px;
  }
  //.main-box2{
  //  overflow-y: scroll;
  //  height: 200px;
  //}

  .el-row {
    margin-bottom: 20px;
    &:last-child {
      margin-bottom: 0;
    }
  }
  .el-col {
    border-radius: 4px;
  }
  .bg-purple-dark {
    background: #99a9bf;
  }
  .bg-purple {
    background: #d3dce6;
  }
  .bg-purple-light {
    background: #e5e9f2;
  }
  .grid-content {
    border-radius: 4px;
    min-height: 36px;
  }
  .row-bg {
    padding: 10px 0;
    background-color: #f9fafc;
  }
  .footer_box{
    height: 30px;
    line-height: 30px;
    color: #7d878b;
    margin-bottom: 8px;
  }

  </style>

<style scoped>
.sidebar-lines-trigger { display:flex; align-items:center; justify-content:center; width:100%; height:44px; padding:8px; border:0; background:transparent; color:var(--theme-muted); cursor:pointer; }
.sidebar-lines-trigger.connected { color:var(--theme-success); }
.sidebar-lines-trigger svg { width:18px; height:18px; animation:line-signal-pulse 2.4s ease-in-out infinite; }
@keyframes line-signal-pulse { 0%,100% { opacity:1; } 50% { opacity:.4; } }
@media(prefers-reduced-motion:reduce) { .sidebar-lines-trigger svg { animation:none; } }
.sidebar-lines-trigger:hover { background:var(--theme-hover); }
.sidebar-lines-trigger:focus-visible { outline:2px solid var(--theme-accent); outline-offset:-3px; }
.app-main-layout { min-width: 0; height: 100vh; overflow: hidden; }
.app-main-layout > .ant-layout-header { flex-shrink: 0; }
.app-main-content { flex: 1; min-height: 0; min-width: 0; overflow: auto; }
</style>
